import React from "react";
import {Input,InputGroup, InputLeftAddon,FormErrorMessage } from "@chakra-ui/react";
const PhoneNumberInput = ({ value, handleChange }) => {
  const handleInputChange=(e)=>{
    handleChange({target:{value:e,name:'phone_number'}});
  }
  return (<>
    <InputGroup className="special-form-group">
      <InputLeftAddon children={`+1`} />
      <Input
        className="sign-phone-number form-control"
        type="number"
        placeholder="Enter Phone Number"
        name="phone_number"
        defaultValue={value}
        maxLength={16}
        onInput={(e) => {
          if ((e.target.value.length > e.target.maxLength) || !e.target.value.match("^[0-9]")) {
            e.target.value = e.target.value.slice(0, e.target.maxLength);
          }
          e.target.value=e.target.value?.toString()?.startsWith("1")?e.target.value.slice(1):e.target.value;
          e.target.value=e.target.value?.toString()?.startsWith("+1")?e.target.value.slice(2):e.target.value;
          handleInputChange(e.target.value)
        }}
        onChange={(e) =>{
          if ((e.target.value.length > e.target.maxLength) || !e.target.value.match("^[0-9]")) {
            e.target.value = e.target.value.slice(0, e.target.maxLength);
          }
          e.target.value=e.target.value?.toString()?.startsWith("1")?e.target.value.slice(1):e.target.value;
          e.target.value=e.target.value?.toString()?.startsWith("+1")?e.target.value.slice(2):e.target.value;
          handleInputChange(e.target.value)
        }}
        onWheel={(e) => e.target.blur()} 
      />
    </InputGroup>
    </>
  );
};

export default PhoneNumberInput;
